<div class="wrapper">
    <app-file-patient [isAdmin]="true" [showRGPDspermission]="false" [showDocumentsTypes]="false" ></app-file-patient>
</div>

